import * as React from "react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { defaultConfig } from "./config";
import { IImageSlider } from "./ImageSlider.types";

const ImageSlider = ({ images, customConfig = {} }: IImageSlider) => {
  const sliderSettings: Partial<Settings> = {
    ...defaultConfig,
    ...customConfig,
  };

  const Images = images.map((image, idx) => {
    return (
      <div key={`${idx + 1}-${image.description}`}>
        <img src={image.imagePath} alt={image.description || ""} />
      </div>
    );
  });

  return <Slider {...sliderSettings}>{Images}</Slider>;
};

export default ImageSlider;
